import React from 'react';
import ReactDOM from 'react-dom';

import BufferTabView from 'buffers/BufferTabView';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

import ProcessDetails from './ProcessDetails';
import ProcessDetailsTabState from './ProcessDetailsTabState';

export default class ProcessDetailsTabView extends BufferTabView<ProcessDetailsTabState> {
  initialize(): void {
    this.listenTo(this.model, 'change:fileId', () => {
      this.render();
    });
  }
  render(): this {
    const props = {
      processId: this.model.get('fileId'),
    };
    renderToDOM(
      <div className="react-tab-container">
        <ProcessDetails {...props} />
      </div>,
      this.el
    );
    return this;
  }

  remove(): Backbone.View<ProcessDetailsTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

ProcessDetailsTabView.prototype.className = 'buffer-tab buffer-tab--no-padding';
